module.exports = __webpack_public_path__ + "static/img/bigEwm1.cd0c2af.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/bigEwm1.png
// module id = jLDq
// module chunks = 0